import { useEffect, useState } from 'react';
import { bookingAPI } from '../../api';
import { Spinner } from '../../components/common/Misc';
import styles from './AdminDashboard.module.css';

const AdminStats = () => {
  const [stats,   setStats]   = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    bookingAPI.getStats()
      .then(res => setStats(res.data.data))
      .catch(() => setStats(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner />;
  if (!stats)  return <p>Failed to load stats.</p>;

  const statusMap = Object.fromEntries(stats.by_status.map(s => [s._id, s.count]));
  const rev = stats.revenue;

  const cards = [
    { label: 'Total revenue',    value: `₹${rev.total_revenue?.toFixed(0) || 0}`,   sub: 'from completed bookings' },
    { label: 'Total bookings',   value: rev.total_bookings || 0,                     sub: 'completed' },
    { label: 'Pending',          value: statusMap.pending    || 0,                   sub: 'awaiting confirmation' },
    { label: 'Active',           value: statusMap.active     || 0,                   sub: 'currently rented' },
    { label: 'Confirmed',        value: statusMap.confirmed  || 0,                   sub: 'upcoming' },
    { label: 'Cancelled',        value: statusMap.cancelled  || 0,                   sub: 'this period' },
  ];

  return (
    <div>
      <div className={styles.statGrid}>
        {cards.map(c => (
          <div key={c.label} className={styles.statCard}>
            <p className={styles.statLabel}>{c.label}</p>
            <p className={styles.statValue}>{c.value}</p>
            <p className={styles.statSub}>{c.sub}</p>
          </div>
        ))}
      </div>

      {stats.popular_bikes?.length > 0 && (
        <>
          <h2 className={styles.sectionTitle} style={{ marginBottom: '1rem' }}>Most booked bikes</h2>
          <div className={styles.tableWrap}>
            <table>
              <thead>
                <tr><th>#</th><th>Bike</th><th>Type</th><th>Bookings</th></tr>
              </thead>
              <tbody>
                {stats.popular_bikes.map((b, i) => (
                  <tr key={b._id}>
                    <td>{i + 1}</td>
                    <td>{b.bike.name}</td>
                    <td style={{ textTransform: 'capitalize' }}>{b.bike.type}</td>
                    <td><strong>{b.count}</strong></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminStats;
